import React from "react";

const Header = () => (
  <header>
    <h1>Mellow Enclave</h1>
    <p>Exclusive Club for the Discerning Few</p>
  </header>
);

export default Header;
